import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-10">
            <div className="col-span-2 md:col-span-1">
              <span className="text-lg font-heading text-background-50 mb-3 block">
                7788电影网
              </span>
              <p className="text-xs md:text-sm text-background-50/50 leading-relaxed">
                {footerData.description}
              </p>
            </div>

            {footerData.sections.map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-medium text-background-50 mb-3 md:mb-4">
                  {section.title}
                </h4>
                {section.links.length > 0 ? (
                  <ul className="flex flex-col gap-2">
                    {section.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          onClick={(e) => {
                            e.preventDefault();
                            scrollTo(link.href);
                          }}
                          className="text-xs md:text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-xs md:text-sm text-background-50/30">
                    虚位以待
                  </p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 md:mt-14 pt-6 md:pt-8 border-t border-background-50/10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-50/30">
                &copy; {new Date().getFullYear()} 7788电影网 版权所有
              </p>
              <p className="text-xs text-background-50/30">
                高清电视剧在线观看 · 追剧首选平台
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}